/**
 * @file Automatically generated by barrelsby.
 */

export * from './navbar.component';
